const DotsGridSolid = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 4.5C9.41421 4.5 9.75 4.16421 9.75 3.75C9.75 3.33579 9.41421 3 9 3C8.58579 3 8.25 3.33579 8.25 3.75C8.25 4.16421 8.58579 4.5 9 4.5Z"
      stroke="#A4A7AE"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 9.75C9.41421 9.75 9.75 9.41421 9.75 9C9.75 8.58579 9.41421 8.25 9 8.25C8.58579 8.25 8.25 8.58579 8.25 9C8.25 9.41421 8.58579 9.75 9 9.75Z"
      stroke="#A4A7AE"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 15C9.41421 15 9.75 14.6642 9.75 14.25C9.75 13.8358 9.41421 13.5 9 13.5C8.58579 13.5 8.25 13.8358 8.25 14.25C8.25 14.6642 8.58579 15 9 15Z"
      stroke="#A4A7AE"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.25 4.5C14.6642 4.5 15 4.16421 15 3.75C15 3.33579 14.6642 3 14.25 3C13.8358 3 13.5 3.33579 13.5 3.75C13.5 4.16421 13.8358 4.5 14.25 4.5Z"
      stroke="#A4A7AE"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.25 9.75C14.6642 9.75 15 9.41421 15 9C15 8.58579 14.6642 8.25 14.25 8.25C13.8358 8.25 13.5 8.58579 13.5 9C13.5 9.41421 13.8358 9.75 14.25 9.75Z"
      stroke="#A4A7AE"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.25 15C14.6642 15 15 14.6642 15 14.25C15 13.8358 14.6642 13.5 14.25 13.5C13.8358 13.5 13.5 13.8358 13.5 14.25C13.5 14.6642 13.8358 15 14.25 15Z"
      stroke="#A4A7AE"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.75 4.5C4.16421 4.5 4.5 4.16421 4.5 3.75C4.5 3.33579 4.16421 3 3.75 3C3.33579 3 3 3.33579 3 3.75C3 4.16421 3.33579 4.5 3.75 4.5Z"
      stroke="#A4A7AE"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.75 9.75C4.16421 9.75 4.5 9.41421 4.5 9C4.5 8.58579 4.16421 8.25 3.75 8.25C3.33579 8.25 3 8.58579 3 9C3 9.41421 3.33579 9.75 3.75 9.75Z"
      stroke="#A4A7AE"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.75 15C4.16421 15 4.5 14.6642 4.5 14.25C4.5 13.8358 4.16421 13.5 3.75 13.5C3.33579 13.5 3 13.8358 3 14.25C3 14.6642 3.33579 15 3.75 15Z"
      stroke="#A4A7AE"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DotsGridSolid;
